import React, { createContext, useCallback, useState, useContext } from 'react';

import api from '~/services/api';

import { AuthState, AuthContextData } from './interface';

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export const AuthProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<AuthState>(() => {
    const data = localStorage.getItem('@milvio:token');
    if (data) {
      const { nome, email, token } = JSON.parse(data);
      api.defaults.headers.common.Passport = `${token}`;
      return { nome, email, token };
    }
    return {} as AuthState;
  });

  const signIn = useCallback(async data => {
    const { nome, email, token } = data;
    localStorage.setItem('@milvio:token', JSON.stringify(data));
    api.defaults.headers.common.Passport = `${token}`;
    setData({ nome, email, token });
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem('@milvio:token');
    setData({} as AuthState);
  }, []);

  return (
    <AuthContext.Provider value={{ data, signIn, signOut }}>
      <>{children}</>
    </AuthContext.Provider>
  );
};

export function useAuth(): AuthContextData {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('hook usada fora de contexto de autenticação!');
  }
  return context;
}
